import CrmPanel from './CrmPanel';

/**
 * A customer's Notes tab (a Sales or Nursery seat): their follow-ups and
 * issues, open first, and a timeline of notes, pinned first, including
 * those written on their orders. A pinned note is also shown on the
 * incoming-call card when they ring. Shown on /accounts/customers/:id?tab=notes.
 */
export default function CustomerNotesTab({ customerId }: { customerId: number }) {
  return <CrmPanel subject={{ customerId }} />;
}
